/*
  Opus: our own copy on Route's shipping protection widget (cart drawer and cart page).
  Route's coverage line ("Your order is protected for CA$3.03") is replaced with a heading,
  the same price, and a line about the carbon offset that comes with every protected order.
  Route re-renders its widget whenever the cart changes, so a MutationObserver re-applies the copy.
  CSS hides Route's own line only while .opus-route-copy is present (assets/cart-line-details.css),
  so if this script fails the original widget still shows.
*/
(() => {
  const HEADING = 'Shipping Protection & Carbon Neutrality';
  const TEXT =
    'Protect your package against loss, theft, or damage, and automatically offset 100% of the emissions from this delivery.';

  const apply = (widget) => {
    const source = widget.querySelector('.pw-coverage-description-default');
    const row = source && source.parentElement;
    if (!row) return;
    const match = source.textContent.match(/[A-Z]{0,3}\$\s?[\d.,]+/);
    const price = match ? match[0] : '';

    let copy = row.querySelector('.opus-route-copy');
    if (!copy) {
      copy = document.createElement('div');
      copy.className = 'opus-route-copy';
      copy.innerHTML =
        '<p class="opus-route-copy__heading"><span class="opus-route-copy__title"></span><span class="opus-route-copy__price"></span></p>' +
        '<p class="opus-route-copy__text"></p>';
      copy.querySelector('.opus-route-copy__title').textContent = HEADING;
      copy.querySelector('.opus-route-copy__text').textContent = TEXT;
      row.appendChild(copy);
    }
    const priceEl = copy.querySelector('.opus-route-copy__price');
    if (priceEl.textContent !== price) priceEl.textContent = price;
  };

  let queued = false;
  const run = () => {
    queued = false;
    document.querySelectorAll('.pw-route-protection').forEach(apply);
  };
  new MutationObserver(() => {
    if (!queued) {
      queued = true;
      // A timer rather than requestAnimationFrame, which never fires in a background tab
      setTimeout(run, 30);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  run();
})();
